import { render } from "./ThePicturesList.vue?vue&type=template&id=6c733e92"
import script from "./ThePicturesList.vue?vue&type=script&lang=js"
export * from "./ThePicturesList.vue?vue&type=script&lang=js"

import "./ThePicturesList.vue?vue&type=style&index=0&id=6c733e92&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__